/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Canvas_Price_FallbackInputs */

const cs_builder_canvas_price_fallback = /** @type {(inputs: Builder_Canvas_Price_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const en_builder_canvas_price_fallback = /** @type {(inputs: Builder_Canvas_Price_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Builder_Canvas_Price_FallbackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_canvas_price_fallback = /** @type {((inputs?: Builder_Canvas_Price_FallbackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Canvas_Price_FallbackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_canvas_price_fallback(inputs)
	return cs_builder_canvas_price_fallback(inputs)
});